<div class="selection-zone-container" [ngClass]="this.dispositionLabel">
	@if (afficherTitre()) {
		<label for="zone">{{ determinerLabelDropdown() }}</label>
	}

	<div class="dropdown-clear-button">
		<div class="dropdown-container">
			<p-dropdown
					[options]="groupesZones"
					[(ngModel)]="_zoneSelectionneeId"
					(ngModelChange)="onZoneChanged($event)"
					[disabled]="_loading"
					[group]="true"
					[emptyMessage]="'SELECTION_ZONE.AUCUNE_ZONE_AUTORISEE' | translate">
				<ng-template let-site pTemplate="group">
					<span>{{ site.label }}</span>
				</ng-template>
			</p-dropdown>
		</div>
		@if (this.mode() === Mode.Modification) {
			<div class="button-saisir-nom-equipe">
				<p-button
						(onClick)="clearZoneSelectionee()"
						[disabled]="!_zoneSelectionneeId"
						icon="pi pi-times"
						[loading]="_loading"/>
			</div>
		}
	</div>
</div>
